// extracted by mini-css-extract-plugin
export default {"title":"Products_title__l-mIy","description":"Products_description__Fn1uT"};